module.exports = __webpack_public_path__ + "static/media/upload-icon.8b28371a.svg";